import Datatable from "./datatable_controller";

// Connects to data-controller="team-invitation-datatable"
export default class extends Datatable {
  connect() {
    super.connect()
  }

  get columns() {
    return [
      {data: 'email'},
      {data: 'role'},
      {data: 'last_sent'},
      {data: 'status'},
      {data: 'actions'}
    ]
  }

  get searching() {
    return false
  }

  get ordering() {
    return false
  }
}
